// extracted by mini-css-extract-plugin
export default {"sideDrawerOption":"SideDrawerOption_sideDrawerOption__jfZ2H","title":"SideDrawerOption_title__FV2-D font-xs-medium"};